import type { CultureCode, LanguageCode } from './types';

const LANGUAGE_TO_CULTURE: Record<LanguageCode, CultureCode> = {
  tr: 'tr-TR',
  en: 'en-US',
};

const CULTURE_TO_LANGUAGE: Record<string, LanguageCode> = {
  tr: 'tr',
  'tr-tr': 'tr',
  en: 'en',
  'en-us': 'en',
  'en-gb': 'en',
};

export function defaultCultureForLanguage(language: LanguageCode): CultureCode {
  return LANGUAGE_TO_CULTURE[language] ?? 'tr-TR';
}

export function languageFromCulture(culture: CultureCode): LanguageCode {
  const normalized = culture.toLowerCase().replace('_', '-');
  const primary = normalized.split('-')[0] ?? 'tr';
  return CULTURE_TO_LANGUAGE[normalized] ?? CULTURE_TO_LANGUAGE[primary] ?? 'tr';
}

export function resolveBrowserCulture(): CultureCode {
  const nav = typeof navigator !== 'undefined' ? navigator.language : 'tr-TR';
  return nav || 'tr-TR';
}

export function resolveBrowserTimeZone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'Europe/Istanbul';
  } catch {
    return 'Europe/Istanbul';
  }
}

/** UTC anını kullanıcı culture + timezone ile gösterir */
export function formatUtcAsLocal(
  utc: Date,
  culture: CultureCode,
  timeZone: string,
  options?: Intl.DateTimeFormatOptions,
): string {
  return new Intl.DateTimeFormat(culture, {
    timeZone,
    ...options,
  }).format(utc);
}

export function formatCurrencyAmount(
  amount: number,
  culture: CultureCode,
  currency: string,
): string {
  return new Intl.NumberFormat(culture, {
    style: 'currency',
    currency,
    currencyDisplay: 'symbol',
  }).format(amount);
}

/** API/DB için her zaman UTC ISO */
export function toUtcIso(date: Date): string {
  return date.toISOString();
}

/** UTC ISO string → Date (her zaman UTC olarak yorumlanır) */
export function parseUtcIso(isoUtc: string): Date {
  const parsed = new Date(isoUtc);
  if (Number.isNaN(parsed.getTime())) {
    throw new RangeError(`Invalid UTC ISO string: ${isoUtc}`);
  }
  return parsed;
}
